import { Column, EmptyScreen, Text } from '~/commonComponents';
import CandidateEmptyScreenIcon from '~/images/candidate-empty-screen-icon.svg';
import { Colors } from '~/themes/colors';

export const EmptyState = () => (
  <EmptyScreen
    Icon={() => (
      <img
        alt="candidate-empty-screen-icon"
        src={CandidateEmptyScreenIcon}
        height={170}
        width={170}
      />
    )}
    title="No candidates yet"
    description={
      <Column alignItems="center" gap={48} marginBottom={146}>
        <Text color={Colors.neutral_500}>
          You haven&apos;t received any applications for this position.
          <br />
          To attract candidates, make sure you&apos;ve posted
          <br />
          enough onsite interviews; this is how dental
          <br />
          professionals apply to your job.
        </Text>
      </Column>
    }
  />
);
